
<ion-content class="employee-work-order">
    <ng-container>
        <app-header [title]="'Employee Work Order Report'"></app-header>
        <div class="loading-container" style="padding-top:15%" *ngIf="!loaded">
            <ion-spinner></ion-spinner>
        </div>
        <ion-grid *ngIf="doneLoading">
            <ion-row>
                <ion-grid class="inner-grid">
                    <ion-row>
                        <ion-col class="ion-no-padding">
                            <ion-row>
                                <ion-col size="auto">Cust: &nbsp;&nbsp;{{customerId}}<strong> &nbsp;&nbsp; {{customer.customerName}}</strong></ion-col>
                            </ion-row>
                            <ion-row>
                                <ion-col class="ion-no-padding">
                                    <ion-col size="auto">Dept: &nbsp;&nbsp;{{departmentId}} <strong>&nbsp;&nbsp; {{customer.departmentName}}</strong></ion-col>
                                </ion-col>
                            </ion-row>
                      <ion-row>
                            <ion-col class="ion-no-padding">
                                <ion-col size="auto">Emp: &nbsp;&nbsp;{{employeeId}} <strong>&nbsp;&nbsp;{{customer.lastName}}, {{customer.firstName}}</strong></ion-col>
                            </ion-col>
                        </ion-row>
                 </ion-col>
                     <ion-col style="float:right">
                        <div style="float:right">
                                    <ion-row >
                                        Report Date: {{ currentDate  | date:'MM/dd/yyyy'}}
                                    </ion-row>
                                     <ion-row>
                                       <button class="printer-button hidden-for-print" (click)="changePrinterView()">{{viewChange === true ? 'Regular Version' : 'Printer Friendly Version'}}</button>
                                    </ion-row>
                                </div>
                    </ion-col>
                    </ion-row>
                   
                </ion-grid>
            </ion-row>
            <ion-row>
                <ion-col>
                    <ion-grid>
                        <ion-row>
                            <ion-col class="small-text"><b>{{customer.lastName}}, {{customer.firstName}}</b>&nbsp;&nbsp;<span>{{customer.deliveryAddress1}}</span></ion-col>
                            <ion-col class="small-text"><b>Stop:</b>&nbsp;&nbsp;<span>{{customer.stop}}</span></ion-col>
                            <ion-col class="small-text"><b>Garment ID Label: </b>&nbsp;&nbsp;<span>{{customer.stopCode}} {{customer.employeeCode}}</span></ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col>
                                <app-work-order-table [rows]="report.report" *ngIf="!viewChange"></app-work-order-table>
                                <app-work-order-table-print class="print-styles" [rows]="report.report" *ngIf="viewChange"></app-work-order-table-print>
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ng-container>
</ion-content>